import { Box, Stack } from "@mui/material";
import type { JSX } from "react";
import { IUICustomizationPresetDescriptionDTO } from "../../../services/ui-customization-data-service/Models";

export type UICustomizationPresetTitleProps = {
    preset: IUICustomizationPresetDescriptionDTO;
};

export default function UICustomizationPresetTitle({
    preset
}: UICustomizationPresetTitleProps): JSX.Element {
    return (
        <Stack direction="row">
            <Box
                sx={{
                    display: "flex",
                    flex: "1 1 auto"
                }}>
                {((preset.name?.length ?? 0) > 0) &&
                    `${preset.name}`
                }
            </Box>
        </Stack>
    );
}
